import { Box } from '@mui/material';
import { useEffect, useState, useMemo } from 'react';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { conformationAlert } from 'services/shared/alert';
import { msgTypes } from 'constants/msgTypes';
import { Formik, Form } from 'formik'
import FormikControl from 'components/wrapperComponents/FormikControl';
import ApiUrl from 'services/shared/ApiUrl';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { UploadCertificateService } from 'services/menu/uploadCertificate/UploadCertificateService';
import { CertificateModel } from 'model/screensModels/CertificateModel';
import { CertificateSchema } from 'schemas/menu/certificate/CertificateSchema';
import Tooltip from '@mui/material/Tooltip';
import DispalyImage from 'components/wrapperComponents/DispalyImage';
import moment from 'moment';
import './CertificateList.scss'


const CertificateList = ({ setIndex, updateRecord, setFlag }) => {

  const [certificateList, setCertificateList] = useState<ResponseModel | null>(null); 
  const [loading, setLoading] = useState(false);
  const [noRecord, setNoRecord] = useState(false);
  const [selectedValues, setSelectedValues] = useState(undefined)
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })


  const isCertificateExpire = (expiryDate: string) =>{
    var now = moment();
    if (now.isBefore(expiryDate) ) {
      return false;
    }
    return true;
  }

  const columns = useMemo(() =>
    [
      {
        accessorKey: "companyName",
        header: "Company Name"
      },
      {
        accessorKey: "certificateName",
        header: "Certificate Name",
        size: 150,
        Cell: ({ row }) => row.original.certificateName ? row.original.certificateName : "NA"
      },
      {
        accessorKey: "expireDate",
        header: "Expire Date",
        size: 50
      },
      {
        accessorKey: "uploadingDate",
        header: "Uploading Date",
        size: 50
      },

      {
        header: 'Certificates',
        Cell: ({ row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {row.original.pdf && row.original.pdf.endsWith('.pdf') ? (
              <a
                href={ApiUrl.fileBaseUrl + row.original.pdf}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: '#1976d2' }}
              >
                {/* <img src={ApiUrl.fileBaseUrl+row.original.image} alt="" /> */}
                < DispalyImage
                  imageUrl={row.original?.image}
                  imageSize={msgTypes.IMAGE_SIZE.SMALL} />
              </a>
            ):""}
          </Box>
        ),
        size: 50
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <>
          { isCertificateExpire(row.original.expireDate)===false ? (
            <div className='d-flex'>
              <Tooltip title="Edit">
                <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
              </Tooltip>
            </div>
          ):(
            <div className='expired-certificate-message'>
              Expired
            </div>
          )}
          </>
        ),
    size: 10,
    grow: false,
},
    ], []);

//Begin:: UseEffect Hooks

useEffect(() => {
  getCertificateList();
}, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])



useEffect(() => {
  if (selectedValues)
    getCertificateList();
}, [pagination.pageNumber, pagination.pageSize])

//End:: UseEffect Hooks


const changeTabIndex = () => {
  setIndex(1);
}


//Prepare request body to get blog list
const prepareRequest = () => {
  const requestBody = new PaginatorModel();
  requestBody.pageNumber = pagination.pageNumber;
  requestBody.pageSize = pagination.pageSize;
  requestBody.filter = pagination.filter;
  requestBody.orderBy = pagination.orderBy;
  requestBody.desc = pagination.desc;
  return requestBody;
}

//Get Certificate list
const getCertificateList = async () => {
  const requestBody = prepareRequest();
  const res = await UploadCertificateService.getCertificateList(requestBody);
  // console.log("Get Certificate is ", res)
  if (res.statusMsg === msgTypes.SUCCESS.msg) {
    setCertificateList(res)
  }
}


//Open Form To edit Record
const editRecord = (record: CertificateModel) => {
  updateRecord(record);
  changeTabIndex();
  setFlag(true);
}

const deleteRecord = async (record: CertificateModel) => {
  const requestData: CertificateModel = new CertificateModel();
  requestData.certificateId = record.certificateId

  const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");
  if (deleteFlag) {
    const res = await UploadCertificateService.deleteCertificate(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      getCertificateList();
    }
  }
}


const initialValues = {}
const onSubmit = () => {
  getCertificateList();
}

return (
  <Formik
    enableReinitialize={true}
    initialValues={initialValues}
    validationSchema={CertificateSchema}
    onSubmit={onSubmit}
  >
    {
      formik =>
      (
        <Form>
            {certificateList ? (
          <CustomTableGrid
            item={
              <FormikControl
                control='materialTable'
                tableColumn={columns}
                tableData={certificateList}
                //formikValue={formik}
                setPagination={setPagination}
            
              />
            }
          />
        ) : null}
        </Form>
      )
    }
  </Formik>
)
}
export default CertificateList;
